import formValidation from '../components/formValidation';
import ErrorNotification from '../components/errorNotification';
import { manageMarketingConsentsDependencies } from '../profile/accountHelpers';

// OTP timer util function
function startOtpTimer() {
    const $button = $('.js-resend-otp');
    const $timer = $('.js-otp-timer');
    const duration = parseInt($button.data('wait-time')) || 60;
    let remaining = duration;

    $timer.text('(' + duration + ')');
    $button.prop('disabled', true);

    const interval = setInterval(() => {
        remaining--;
        $timer.text('(' + remaining + ')');
        if (remaining <= 0) {
            clearInterval(interval);
            $timer.text('');
            $button.prop('disabled', false);
        }
    }, 1000);
}
export default class Login {
    init() {
        this.login();
        this.register();
        this.resetPassword();
        this.clearResetForm();
        this.manageOtp();
        this.manageMarketingConsents();
    }

    login() {
        $('form.login').submit(function (e) {
            e.preventDefault();
            const form = $(this);
            const action = $('form.login .btn');
            const url = form.attr('action');
            const loginContainer = $('.login-form-nav');

            loginContainer.spinner().start();
            $('form.login').trigger('login:submit', e);
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    if (!data.success) {
                      loginContainer.spinner().stop();
                      formValidation(form, data);
                      $('form.login').trigger('login:error', data);
                    } else {
                      $('form.login').trigger('login:success', data);
                      window.location.href = data.redirectUrl;
                    }
                },
                error(data) {
                    if (data.responseJSON.redirectUrl) {
                        window.location.href = data.responseJSON.redirectUrl;
                    } else {
                        $('form.login').trigger('login:error', data);
                        loginContainer.spinner().stop();
                    }
                },
            });
            return false;
        });
    }

    register() {
        $('form.registration').submit(function (e) {
            e.preventDefault();
            const form = $(this);
            const action = $('form.registration .btn');
            const url = form.attr('action');

            action.spinner().start();
            grecaptcha
              .execute(form.find('.g-recaptcha').data('data-sitekey'), {
                action: 'submit'
              })
              .then((token) => {
                const tokenInput = $('#registration-token');
                tokenInput.val(token);
                $('form.registration').trigger('login:register', e);
                $.ajax({
                    url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success(data) {
                        action.spinner().stop();
                        if (!data.success) {
                            $('form.registration').trigger('login:register:error', data);
                            formValidation(form, data);
                        } else {
                            $('form.registration').trigger('login:register:success', data);
                            window.location.href = data.redirectUrl;
                        }
                    },
                    error(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            new ErrorNotification($('.error-messaging'), err.responseJSON.errorMessage).init();
                        }

                        action.spinner().stop();
                    },
                });
              })
              .catch(() => {
                action.spinner().stop();
              });

            return false;
        });
    }

    resetPassword() {
        $('.reset-password-form').submit(function (e) {
            e.preventDefault();
            const form = $(this);
            const url = form.attr('action');

            $('.submit-email-button').spinner().start();
            $('.reset-password-form').trigger('login:register', e);
            $.ajax({
                url,
                type: 'post',
                dataType: 'json',
                data: form.serialize(),
                success(data) {
                    $('.submit-email-button').spinner().stop();
                    if (!data.success) {
                        formValidation(form, data);
                    } else {
                        $('.request-password-title').text(data.receivedMsgHeading);
                        $('.request-password-body').empty()
                            .append(`<p>${data.receivedMsgBody}</p>`);
                        if (!data.mobile) {
                            $('.submit-email-button').text(data.buttonText)
                                .attr('data-dismiss', 'modal');
                        } else {
                            $('.send-email-btn').empty()
                                .html(`<a href="${
                                    data.returnUrl
                                }" class="btn btn-primary">${
                                    data.buttonText}</a>`);
                        }
                    }
                },
                error() {
                    form.spinner().stop();
                },
            });
            return false;
        });
    }

    clearResetForm() {
        $('#login .modal').on('hidden.bs.modal', () => {
            $('#reset-password-email').val('');
            $('.modal-dialog .form-control.is-invalid').removeClass('is-invalid');
        });
    }

    manageOtp() {
        $('form.js-manage-otp').on('submit', function (e) {
            e.preventDefault();
            const form = $(this);
            const url = form.attr('action');

            if (form.hasClass('js-send-otp')) {
                const $fidelityInput = form.find('#registration-form-fidelity-card-number');
                const rawValue = ($fidelityInput.val() || '').trim();
                const cleanedValue = rawValue.replace(/[\s-]/g, '');
                const isValid = /^[0-9]{13}$/.test(cleanedValue);
                if (!isValid) {
                    const errorMsg = !rawValue
                        ? $fidelityInput.data('missingError')
                        : ($fidelityInput.data('rangeError') || $fidelityInput.data('patternMismatch'));
                    formValidation(form, { fields: { fidelityCardNo: errorMsg } });
                    return false;
                }
                $fidelityInput.val(cleanedValue);
            }

            $.spinner().start();
            grecaptcha
              .execute(form.find('.g-recaptcha').data('data-sitekey'), {
                action: 'submit'
              })
              .then((token) => {
                const tokenInput = form.find('.otpToken');
                tokenInput.val(token);
                
                $.ajax({
                    url,
                    type: 'post',
                    dataType: 'json',
                    data: form.serialize(),
                    success(data) {
                        $.spinner().stop();
                        if (!data.success) {
                            if (data.message && !data.fields) {
                                var fieldName = form.hasClass('js-send-otp') ? 'fidelityCardNo' : (form.hasClass('js-validate-otp') ? 'fidelityOTP' : null);
                                if (fieldName) {
                                    data.fields = {};
                                    data.fields[fieldName] = data.message;
                                }
                            }
                            formValidation(form, data);
                        } else {
                            if (form.hasClass('js-send-otp')) {
                                $('#current-card-number').val(data.fidelityCardNo);
                                $('#fidelity-registration-otp-request').addClass('d-none');
                                $('#fidelity-registration-otp-validation').removeClass('d-none');
                                startOtpTimer();
                            } else if (form.hasClass('js-validate-otp')) {
                                Object.keys(data.customer).forEach(key => {
                                    var $currentField = $('#' + key);
                                    if (!$currentField.length) {
                                        return;
                                    }
                                    if ($currentField.prop('type') === 'checkbox') {
                                        $currentField.prop('checked', data.customer[key]);
                                    } else {
                                        var dataValue = data.customer[key];
                                        var hasDataValue = dataValue !== null && dataValue !== undefined
                                            && String(dataValue).trim() !== '';
                                        if (hasDataValue) {
                                            $currentField.val(dataValue);
                                            $currentField.prop('readonly', true);
                                        } else {
                                            $currentField.prop('readonly', false);
                                        }
                                        if (key === 'registration-form-email') {
                                            var $emailConfirm = $('#registration-form-email-confirm');
                                            if (hasDataValue) {
                                                $emailConfirm.val(dataValue);
                                                $emailConfirm.prop('readonly', true);
                                            } else {
                                                $emailConfirm.prop('readonly', false);
                                            }
                                        }
                                    }
                                });
                                $('.js-fidelity-card-registration-container').addClass('d-none');
                                $('.js-register-form-title-container').addClass('d-none');
                            }
                        }
                    },
                    error(err) {
                        if (err.responseJSON.redirectUrl) {
                            window.location.href = err.responseJSON.redirectUrl;
                        } else {
                            new ErrorNotification($('.error-messaging'), err.responseJSON.errorMessage).init();
                        }

                        $.spinner().stop();
                    },
                });
              })
              .catch(() => {
                $.spinner().stop();
              });

            return false;
        });

        $('body').on('click', '.js-resend-otp', function (e) {
            $('form#fidelity-registration-otp-request').trigger('submit');
        });
    }

    manageMarketingConsents() {
        manageMarketingConsentsDependencies();
    }
}
